// Generated by genversion.
export const version = '11.2.0'
